/**
 * Token cookie 工具模块
 * 将 access_token / refresh_token 存储在 cookie 中
 */

const EXPIRES_TIME = 24 * 60 * 60 * 1000;
function getCookie(name) {
  const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}
function setCookie(name, value) {
  const expires = new Date(Date.now() + EXPIRES_TIME).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; expires=${expires}`;
}
function removeCookie(name) {
  document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
}
export function getAccessToken() {
  return getCookie('access_token');
}
export function setAccessToken(token) {
  setCookie('access_token', token);
}
export function removeAccessToken() {
  removeCookie('access_token');
}
export function getRefreshToken() {
  return getCookie('refresh_token');
}
export function setRefreshToken(token) {
  setCookie('refresh_token', token);
}
export function removeRefreshToken() {
  removeCookie('refresh_token');
}